import { useTranslation } from 'react-i18next';

export default function LendingRatesSection() {
  const { t } = useTranslation();
  
  return (
    <section className="py-16 bg-gray-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <div className="inline-block bg-yellow-500 text-gray-900 px-6 py-2 rounded-full font-bold text-lg mb-6">
            {t('lending.rates.badge')}
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
            {t('lending.rates.title')}
          </h2>
          <p className="text-xl text-gray-300">
            {t('lending.rates.subtitle')}
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 mb-12">
          <div className="bg-gradient-to-br from-green-900/40 to-teal-900/40 border border-green-700 rounded-2xl p-8 text-center">
            <div className="mb-6">
              <div className="text-6xl font-bold text-green-400 mb-2">21</div>
              <div className="text-2xl text-white">{t('lending.rates.currencies')}</div>
            </div>
            <img 
              src="https://mycoinlending.com/images/currency.png"
              alt="Supported Currencies"
              className="w-full max-w-md mx-auto"
            />
          </div>

          <div className="bg-gradient-to-br from-purple-900/40 to-pink-900/40 border border-purple-700 rounded-2xl p-8 text-center">
            <div className="mb-6">
              <div className="flex items-center justify-center gap-2">
                <span className="text-3xl text-white">{t('lending.rates.annual')}</span>
                <span className="text-7xl font-bold text-yellow-400">13.2</span>
                <span className="text-3xl text-white">%</span>
              </div>
            </div>
            <img 
              src="https://mycoinlending.com/images/trader.png"
              alt="Professional Traders"
              className="w-full max-w-md mx-auto mb-6"
            />
            <p className="text-gray-300 text-lg leading-relaxed">
              {t('lending.rates.desc')}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
